import { AivaSparkleIcon } from "./icons";
import styles from "./ProvenanceFooter.module.css";

interface ProvenanceFooterProps {
  /** Opens the AI disclaimer (AIVA-6639). The link is omitted when not provided. */
  readonly onAiNoticeClick?: () => void;
  readonly aiNoticeLabel?: string;
}

export function ProvenanceFooter({ onAiNoticeClick, aiNoticeLabel = "AI Notice" }: Readonly<ProvenanceFooterProps> = {}) {
  return (
    <div className={styles.footer}>
      <span className={styles.footerIcon}><AivaSparkleIcon /></span>
      <span className={styles.footerBrand}>Powered by AiVA</span>
      <span className={styles.footerSep}>•</span>
      {onAiNoticeClick && (
        <>
          <button type="button" className={styles.footerLink} onClick={onAiNoticeClick}>
            {aiNoticeLabel}
          </button>
          <span className={styles.footerSep}>•</span>
        </>
      )}
      <span className={styles.footerOrg}>Executed by Williams Lea</span>
    </div>
  );
}
